import { render, staticRenderFns } from "./SubTitle.vue?vue&type=template&id=2072f9ee&scoped=true&"
import script from "./SubTitle.vue?vue&type=script&lang=js&"
export * from "./SubTitle.vue?vue&type=script&lang=js&"
import style0 from "./SubTitle.vue?vue&type=style&index=0&id=2072f9ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2072f9ee",
  null
  
)

export default component.exports